import { useState, useRef, useEffect } from 'react';

const EventTypeMessage = ({ onSelect }) => {
  const eventTypes = [
    { id: 'birthday', icon: '🎂', title: 'Birthday Party' },
    { id: 'wedding', icon: '💒', title: 'Wedding' },
    { id: 'meeting', icon: '💼', title: 'Meeting' },
    { id: 'party', icon: '🎉', title: 'Party' },
    { id: 'conference', icon: '🎤', title: 'Conference' }
  ];

  return (
      <div>
        <div>Choose your event type: </div>
        <div className="flex flex-wrap gap-3">
            {eventTypes.map((type) => (
              <button
                 key={type.id}
                 onClick={() => onSelect(type.id)}
                 className="flex flex-col items-center p-4 bg-white rounded-lg shadow-sm border border-gray-200 hover:border-purple-500 transition-colors cursor-pointer w-[calc(50%-0.75rem)]"
              >
              <span className="text-2xl mb-2">{type.icon}</span>
              <span className="text-sm font-medium">{type.title}</span>
              </button>
            ))}
        </div>
      </div>
  );
};

export default EventTypeMessage;